import { put, takeLatest } from 'redux-saga/effects';

import { api, getResponseOr404 } from 'shared/sdk';

const actionPrefix = 'Dashboard/Posts/';

const FETCH_POST_DETAILS = `${actionPrefix}FETCH_POST_DETAILS`;
const SUCCESS_FETCH_POST_DETAILS = `${actionPrefix}SUCCESS_FETCH_POST_DETAILS`;

export const fetchPostDetails = ({ postId }) => ({
  type: FETCH_POST_DETAILS,
  payload: { postId }
});

const successFetchPostDetails = payload => ({
  type: SUCCESS_FETCH_POST_DETAILS,
  payload
});

export const postDetailsReducer = (state, action) => {
  switch (action.type) {
    case FETCH_POST_DETAILS:
      state['isFetching'] = true;
      break;

    case SUCCESS_FETCH_POST_DETAILS:
      state['posts'] = [action.payload];
      state['isFetching'] = false;
      break;

    default:
      return state;
  }

  return state;
};

function* fetchPostDetailsWorker(action) {
  const { postId } = action.payload;

  const response = yield getResponseOr404(api.postDetail, {
    lookupData: { postId }
  });

  if (response.success) {
    yield put(successFetchPostDetails(response.data));
  }
}

export function* postDetailsSaga() {
  yield takeLatest(FETCH_POST_DETAILS, fetchPostDetailsWorker);
}
